import { PaymentState } from "./payment.enum";

export const PaymentOptions = [
    { value: PaymentState.UNPAID, label: 'Da pagare' },
    { value: PaymentState.PAID_CASH, label: 'Pagato in contanti' },
    { value: PaymentState.PAID_CARD, label: 'Pagato con cc' },
    { value: PaymentState.PAID_BANCOMAT, label: 'Pagato con bancomat' },
    { value: PaymentState.PAID_BANK, label: 'Pagato con bonifico' },
]